<div mat-dialog-content>
  <mat-stepper linear #stepper>
    <mat-step [stepControl]="typeGroup" [completed]="typeControl.value !== null && typeControl.value.length > 0">
      <form [formGroup]="typeGroup">
        <br>
        <ng-template matStepLabel>Select Type</ng-template>
        <mat-form-field>
          <mat-label>Type</mat-label>
          <mat-select [formControl]="typeControl" required>
            <mat-option *ngFor="let type of types" [value]="type">
              {{type}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div>
          <button mat-button matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="nameGroup" [completed]="nameControl.value !== null && nameControl.value.length > 0">
      <form [formGroup]="nameGroup">
        <br>
        <ng-template matStepLabel>Enter reason</ng-template>
        <mat-form-field>
          <mat-label>Reason</mat-label>
          <input matInput [formControl]="nameControl" required>
        </mat-form-field>
        <div>
          <button mat-button matStepperNext>Next</button>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="ownerGroup" [completed]="(this.permanent) || (this.ownerControl.value !== null && this.ownerControl.value.length > 0)">
      <form [formGroup]="ownerGroup">
        <br>
          <mat-checkbox (change)="setPermanent($event.checked)"></mat-checkbox>
         Permanent?
          <br>
          <input *ngIf="!this.permanent" [required]="!this.permanent" type="datetime-local" [formControl]="ownerControl">
        <br><br>
        <div>
          <button [disabled]="checkSaveDisabled()" (click)="save()" mat-raised-button color="primary">Punish</button>
        </div>
      </form>
    </mat-step>
  </mat-stepper>
</div>
